// awsConfig.js
import { LocationClient } from "@aws-sdk/client-location";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { GeoPlacesClient, AutocompleteCommand } from "@aws-sdk/client-geo-places";
import { getConfig } from "../configLoader";
let { apiUrl, identityPoolId, placeIndexName, region } = getConfig();

/**
 * POINTEL
 * const REGION = "us-east-1"; // Your AWS region
 * const IDENTITY_POOL_ID = "us-east-1:47126de4-e65c-4e56-931b-13dc66641497"; // Your Cognito Identity Pool 
 */

/****
 * SCG DEV MANUAL
 * const REGION = "us-west-2"; // Your AWS region
 * const IDENTITY_POOL_ID = "us-west-2:f7140bb2-6e00-4563-8c24-73c51a898256"; // Your Cognito Identity Pool
 */

/**
 * SCG DEV TERRAFORM
 * const REGION = "us-west-2"; // Your AWS region
 * const IDENTITY_POOL_ID = "us-west-2:ff4d3342-9e34-4705-b379-68ae5d864ecf"; // Your Cognito Identity Pool
 */
const REGION = region;
const IDENTITY_POOL_ID = identityPoolId;

export const locationClient = new LocationClient({
  region: REGION,
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: REGION },
    identityPoolId: IDENTITY_POOL_ID,
  }),
});


export const geoPlacesClient = new GeoPlacesClient({
  region: REGION,
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: REGION },
    identityPoolId: IDENTITY_POOL_ID,
  }),
});

